import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchEvaluations(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('purchase/vendor-evaluations', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteEvaluation(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`purchase/vendor-evaluations/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
